import React from 'react'
import { connect } from 'react-redux'
import { Field, formValueSelector } from 'redux-form'
import { RadioGroup } from '../../../../../../../../../itrust_common/components/form'
import { dateFormat } from '../../../../../../../../../itrust_common/components/HelperFunctions'
import SpecteraFormButton from '../../../spectera/claimForm/SpecteraFormButton'
import { getVisibleStepFields } from '../versantClaimHelper'
import VersantSpectacleLensFields from './VersantSpectacleLensFields'
import VersantSearchSelect from './VersantSearchSelect'

const selector = formValueSelector('VersantClaimForm')
const YES_NO = [{ label: 'Yes', value: true }, { label: 'No', value: false }]
const req = (label) => <>{label} <span className="text-danger">*</span></>

const RADIOS = [
  ['dilationPerformed', 'Dilated Eye Exam (OR) Fundus Photography performed'],
  ['isMemberDiabetic', 'Is the member diabetic?'],
]

const BOXED_SELECTS = [
  ['diabeticCodes', 'Disease Reporting Diagnosis (Check all known conditions for this patient.)'],
  ['diabeticCodes', 'Additional conditional list'],
]

function VersantStep2({ fields, claimId, dateOfService, serviceCategories, sourceSubSystem, backStep }) {
  const radios = RADIOS.filter(([key]) => fields.includes(key))
  const showDiabeticCodes = fields.includes('diabeticCodes')

  return (
    <div className='bg-white p-6 border rounded'>
      {radios.length > 0 && (
        <div className='row'>
          {radios.map(([key, label]) => (
            <RadioGroup
              key={key}
              name={`versant.${key}`}
              label={req(label)}
              options={YES_NO}
              wrapperClasses="col-6 form-group"
              isButtonsNormal
              disabled
            />
          ))}
        </div>
      )}

      {showDiabeticCodes && (
        <div className='row'>
          {BOXED_SELECTS.map(([key, label], index) => (
            <div key={`${key}-${index}`} className="col-6">
              <div className="border rounded p-4 bg-white h-100">
                <div className="form-group exam-auto-select">
                  <label>{req(label)}</label>
                  <input className="form-control" value="None" disabled />
                </div>
              </div>
            </div>
          ))}
        </div>
      )}

      {fields.includes('spectacle_lens') && <div className={radios.length || showDiabeticCodes ? 'mt-6' : ''}><VersantSpectacleLensFields /></div>}

      {(fields.includes('diagnosisCodes') || fields.includes('procedureCodes')) && (
        <div className={`row ${radios.length || showDiabeticCodes || fields.includes('spectacle_lens') ? 'mt-6' : ''}`}>
          {fields.includes('diagnosisCodes') && (
            <Field
              name="services.diagnosisCodes"
              label={req('Please Enter Diagnosis Codes')}
              component={VersantSearchSelect}
              claimId={claimId}
              dateOfService={dateOfService}
              wrapperClasses="col-6 form-group exam-auto-select"
            />
          )}
          {fields.includes('procedureCodes') && (
            <Field
              name="services.procedureCodes"
              label={req('Please Enter Procedure Codes')}
              component={VersantSearchSelect}
              claimId={claimId}
              dateOfService={dateOfService}
              serviceCategories={serviceCategories}
              sourceSubSystem={sourceSubSystem}
              wrapperClasses="col-6 form-group exam-auto-select"
            />
          )}
        </div>
      )}

      <SpecteraFormButton backStep={backStep} buttonClasses="py-2" />
    </div>
  )
}

export default connect((state) => {
  const eligibilityData = selector(state, 'eligibility.data') || []
  const activeModule = state.visionInsuranceClaimForm.editing.activeModule || 'second'
  return {
    fields: getVisibleStepFields(eligibilityData, activeModule),
    claimId: state.visionInsuranceClaimForm.visionInsuranceClaimForm?.id,
    dateOfService: dateFormat(state.order.order?.order_date, 'MM/DD/YYYY'),
    serviceCategories: eligibilityData.filter((item) => item.active).map((item) => item.service_type),
    sourceSubSystem: state.visionInsuranceClaimForm.visionInsuranceClaimForm?.other_details?.member?.sourceSubSystem,
    backStep: activeModule === 'spectacle' ? 'second' : 'first',
  }
})(VersantStep2)
